
export function planPermission(value,plan){
    let findPlan = plan?.typeArr?.findIndex((item) => item.value == value)
    if (findPlan >= 0) {
        return true
    } else {
        return false
    }
}